import { useContext, useEffect, useState } from 'react';
import { getMembresias } from '../../services/getMembresias';
import UserContext from '../../context/userContext';
import { Button, Heading, Input, InputGroup, InputLeftAddon, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, useDisclosure } from '@chakra-ui/react';
import { Loading } from '../Common/Loading';
import { crearMembresia, deleteMembresia } from '../../services/modificarMembresia';
import Select from 'react-select';
import InfoModal from '../util/confirmModal/InfoModal';
import ConfirmModal from '../util/confirmModal/confirmModal';
import Pagination from '../util/pagination/pagination';
import { useTranslation } from 'react-i18next';

const Membresias = () => {

  const { t } = useTranslation();

  const defaultInfoModal = {
    title: '',
    message: '',
    isOpen: false,
    isError: false,
    callback: null,
  }

  const defaultConfirmModal = {
    title: '',
    message: '',
    isOpen: false,
    onClose: null,
    onConfirm: null,
    id: null
  }

  const [confirmModal, setConfirmModal] = useState(defaultConfirmModal);

  const [infoModal, setInfoModal] = useState(defaultInfoModal);
  const { user } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);
  const [membresias, setMembresias] = useState([]);
  const [totalPaginasMembresias, setTotalPaginasMembresias] = useState(1);
  const [paginaActualMembresias, setPaginaActualMembresias] = useState(1);

  const [error, setError] = useState({ error: false, msg: '' });

  const [tipo, setTipo] = useState({ value: 'BAMBU', label: 'Bambú' });
  const [precio, setPrecio] = useState(0);
  const [precioM2, setPrecioM2] = useState(0);
  const [periodoInicio, setPeriodoInicio] = useState('');
  const [periodoFin, setPeriodoFin] = useState('');

  const [errorPrecio, setErrorPrecio] = useState(null);
  const [errorPrecioM2, setErrorPrecioM2] = useState(null);
  const [errorPeriodoInicio, setErrorPeriodoInicio] = useState(null);
  const [errorPeriodoFin, setErrorPeriodoFin] = useState(null);

  const [loadingLocal, setLoadingLocal] = useState(false);

  const tipoOpciones = [
    { value: 'BAMBU', label: t('BAMBU') },
    { value: 'MEZQUITE', label: t('MEZQUITE') },
    { value: 'PIRUL', label: t('PIRUL') },
  ]

  const {
    isOpen: isOpenAddMembresia,
    onOpen: onOpenAddMembresia,
    onClose: onCloseAddMembresia,
  } = useDisclosure();

  // const handleUpdateMembresia = async (idMembresia, precio, precioM2) => {
  //   try {
  //     setIsLoading(true);
  //     const {
  //       data: { membresias: newMembresias },
  //       status,
  //     } = await modificarMembresia(user.id, idMembresia, precio, precioM2);

  //     if (status !== 200) {
  //       setIsLoading(false);
  //       return;
  //     }

  //     setMembresias(newMembresias);
  //     setIsLoading(false);
  //   } catch (error) {
  //     console.log(error);
  //     setIsLoading(false);
  //   }
  // };

  const requestPostMembresia = async () => {
    const isValid = await checkInput.checkAll()
    if(!isValid) {
      return
    }
    setLoadingLocal(true);
    try{
      const response = await crearMembresia(
        tipo.value,
        precio,
        precioM2,
        (new Date(periodoInicio)).toISOString(),
        (new Date(periodoFin)).toISOString()
      )
      requestMembresias()
      onCloseModal()
    }catch(error){
      const message = error.response && error.response.data && error.response.data.msg ? error.response.data.msg : t('ERROR_CREATING_MEMBERSHIP');
      setInfoModal({
        title: 'Error',
        message,
        isOpen: true,
        isError: true,
        callback: null,
      });
    }finally{
      setLoadingLocal(false);
    }
  }

  const requestDelete = async (id) => {
    setLoadingLocal(true);
    try {
      await deleteMembresia(id);
      requestMembresias();
    }catch (error) {
      const message = error.response && error.response.data && error.response.data.msg ? error.response.data.msg : t('ERROR_DELETING_MEMBERSHIP');
      setInfoModal({
        title: 'Error',
        message,
        isOpen: true,
        isError: true,
        callback: null,
      });
    }finally{
      setConfirmModal(defaultConfirmModal);
      setLoadingLocal(false);
    }
  }

  const onCloseModal = () => {
      setTipo({ value: 'BAMBU', label: t('BAMBU') });
      setPrecio(0);
      setPrecioM2(0);
      setPeriodoInicio('');
      setPeriodoFin('');
      onCloseAddMembresia();
      setErrorPrecio(null);
      setErrorPrecioM2(null);
      setErrorPeriodoInicio(null);
      setErrorPeriodoFin(null);
      setError({ error: false, msg: '' });
  }

  const requestMembresias = async () => {
    setIsLoading(true);
    try {
      const response = await getMembresias(user.id, paginaActualMembresias);
      if (response.status !== 200) {
        setError({ error: true, msg: 'Error obteniendo membresías.' });
        return;
      }
      const datedMembresias = response.data.membresias.map(membresia => {
        return {
          ...membresia,
          periodoInicio: membresia.periodoInicio ? new Date(membresia.periodoInicio) : null,
          periodoFin: membresia.periodoFin ? new Date(membresia.periodoFin) : null,
        };
      })
      setMembresias(response.data.membresias);
      setTotalPaginasMembresias(response.data.totalPages);
    } catch (error) {
      setError({ error: true, msg: error });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    requestMembresias();
  }, [paginaActualMembresias, user.id])

  if (isLoading) return <Loading />;

  if (error.error && !isLoading) return <div>Error: {error.msg}</div>;
  

  const checkInput = {
    precio: async () => {
      const precioFloat = parseFloat(precio);
      if(isNaN(precioFloat)) {
        setErrorPrecio(t('PRICE_MUST_BE_NUMBER'));
        return false;
      }
      if (precio <= 0) {
        setErrorPrecio(t('PRICE_GREATER_THAN_ZERO'));
        return false;
      }
      setErrorPrecio(null);
      return true;
    },
    precioM2: async () => {
      const precioM2Float = parseFloat(precioM2);
      if(isNaN(precioM2Float)) {
        setErrorPrecioM2(t('PRICE_PER_M2_MUST_BE_NUMBER'));
        return false;
      }
      if (precioM2 <= 0) {
        setErrorPrecioM2(t('PRICE_PER_M2_GREATER_THAN_ZERO'));
        return false;
      }
      setErrorPrecioM2(null);
      return true;
    },
    periodoInicio: async () => {
      if (!periodoInicio) {
        setErrorPeriodoInicio(t('START_PERIOD_REQUIRED'));
        return false;
      }
      setErrorPeriodoInicio(null);
      return true;
    },
    periodoFin: async () => {
      if (!periodoFin) {
        setErrorPeriodoFin(t('END_PERIOD_REQUIRED'));
        return false;
      }
      if(new Date(periodoFin) <= new Date(periodoInicio)) {
        setErrorPeriodoFin(t('END_PERIOD_GREATER_THAN_START'));
        return false;
      }
      setErrorPeriodoFin(null);
      return true;
    },
    checkAll: async (skip=[]) =>{
      let result = true
      for(const key in checkInput){
          if(key === "checkAll" || skip.findIndex(itm => itm === key) !== -1){
              continue
          }
          const response = await checkInput[key]()
          if(result && !response){
              result = false
          }
      }
      return result
    }
  }

  const renderCreateModal = () => {
    return (
      <Modal isOpen={isOpenAddMembresia} onClose={onCloseModal}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {t('ADD_PERIOD')}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <div className='form-group'>
              <label htmlFor="tipo">{t('MEMBERSHIP_TYPE')}</label>
              <Select
                id="tipo"
                options={tipoOpciones}
                onChange={(value) => setTipo(value)}
                value={tipo}
                placeholder={`${t('SELECT_MEMBERSHIP')}`}
              />
            </div>
            <div className='form-group'>
              <label htmlFor="precio">{t('PRICE')}</label>
              <InputGroup>
                <InputLeftAddon>$</InputLeftAddon>
                <Input
                  id="precio"
                  type="number"
                  className="form-control"
                  value={precio}
                  onChange={(e) => setPrecio(e.target.value)}
                  onBlur= {checkInput.precio}
                />
              </InputGroup>
              {
                errorPrecio && (
                  <span className="text-danger">
                    {errorPrecio}
                  </span>
                )
              }
            </div>
            <div className='form-group'>
              <label htmlFor="precioM2">{t('PRICE_PER_M2')}</label>
              <InputGroup>
                <InputLeftAddon>$</InputLeftAddon>
                <Input
                  id="precioM2"
                  type="number"
                  className="form-control"
                  value={precioM2}
                  onChange={(e) => setPrecioM2(e.target.value)}
                  onBlur= {checkInput.precioM2}
                />
              </InputGroup>
              {
                errorPrecioM2 && (
                  <span className="text-danger">
                    {errorPrecioM2}
                  </span>
                )
              }
            </div>
            <div className='form-group'>
              <label htmlFor="periodoInicio">{t('START_PERIOD')}</label>
              <Input
                type="date"
                className="form-control"
                id="periodoInicio"
                value={periodoInicio}
                onChange={(e) => setPeriodoInicio(e.target.value)}
                onBlur= {checkInput.periodoInicio}
              />
              {
                errorPeriodoInicio && (
                  <span className="text-danger">
                    {errorPeriodoInicio}
                  </span>
                )
              }
            </div>
            <div className='form-group'>
              <label htmlFor="periodoFin">{t('END_PERIOD')}</label>
              <Input
                type='date'
                className="form-control"
                id="periodoFin"
                value={periodoFin}
                onChange={(e) => setPeriodoFin(e.target.value)}
                onBlur= {checkInput.periodoFin}
              />
              {
                errorPeriodoFin && (
                  <span className="text-danger">
                    {errorPeriodoFin}
                  </span>
                )
              }
            </div>
            <div style={{"textAlign": "right", marginTop: "20px", marginBottom: "20px"}}>
              <Button 
                colorScheme='blue' 
                isLoading={loadingLocal} 
                onClick={requestPostMembresia}
                loadingText={t('CREATING')}
                isDisabled={loadingLocal}
              >
                {t('CREATE')}
              </Button>
              <Button ml={3} onClick={onCloseModal}>
                {t('CANCEL')}
              </Button>
            </div>
          </ModalBody>
        </ModalContent>
      </Modal>
    )
  }

  return (
    <div className="py-3 px-5">
      <Heading size="lg">{t('MEMBERSHIP_PERIODS')}</Heading>
      <div style={{width: '100%', textAlign: 'right'}}>
        <Button onClick={onOpenAddMembresia} colorScheme="blue" my="4">
          + {t('ADD_PERIOD')}
        </Button>
      </div>
      <div
        className="mt-1"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        }}
      >
        <TableContainer>
          <Table variant="simple">
            <Thead>
              <Tr>
                <Th>{t('MEMBERSHIP_TYPE')}</Th>
                <Th>{t('PRICE')}</Th>
                <Th>{t('PRICE_PER_M2')}</Th>
                <Th>{t('START_PERIOD')}</Th>
                <Th>{t('END_PERIOD')}</Th>
                <Th></Th>
              </Tr>
            </Thead>
            <Tbody>
              {
                membresias.map((membresia) => (
                  <Tr key={membresia.id}>
                    <Td>{membresia.membresia.tipo}</Td>
                    <Td>${membresia.precio}</Td>
                    <Td>${membresia.precioM2}</Td>
                    <Td>
                      {
                        membresia.periodoInicio ? 
                        membresia.periodoInicio.split('T')[0]
                        : '-'
                      }
                    </Td>
                    <Td>
                      {
                        membresia.periodoFin ?
                        membresia.periodoFin.split('T')[0]
                        : '-'
                      }
                    </Td>
                    <Td>
                      <Button 
                        colorScheme='red'
                        onClick={() => {
                          setConfirmModal({
                            title: t('DELETE_MEMBERSHIP'),
                            message: t('CONFIRM_DELETE_MEMBERSHIP'),
                            isOpen: true,
                            id: membresia.id,
                            onClose: () => {
                              setConfirmModal(defaultConfirmModal);
                            },
                            onConfirm: () => {
                              requestDelete(membresia.id);
                            },
                          });
                        }}
                      >
                        Borrar 
                      </Button>
                    </Td>
                  </Tr>
                ))
              }
            </Tbody>
          </Table>
        </TableContainer>
        {
          renderCreateModal()
        }
        <ConfirmModal
          title={confirmModal.title}
          message={confirmModal.message}
          isOpen={confirmModal.isOpen}
          onClose={() => {
            setConfirmModal(defaultConfirmModal);
          }}
          onConfirm={confirmModal.onConfirm}
          isLoading={loadingLocal}
        />
        <InfoModal
          title={infoModal.title}
          message={infoModal.message}
          isOpen={infoModal.isOpen}
          onClose={() => {
            setInfoModal(defaultInfoModal);
          }}
          isError={infoModal.isError}
          callback={infoModal.callback}
        />
      </div>
      <Pagination
          pageCount={totalPaginasMembresias}
          currentPage={paginaActualMembresias}
          onPageChange={(page) => {
            setPaginaActualMembresias(page);
          }}
        />
    </div>
  );
};

export default Membresias;

export const Membresia = ({ membresia, isLoading, handleUpdateMembresia }) => {
  const { t } = useTranslation();
  const [precio, setPrecio] = useState(membresia.precio);
  const [precioM2, setPrecioM2] = useState(membresia.precioM2 || 0);

  const transformTipoCabana = (tipo) => {
    let name = '';
    switch (tipo) {
      case 'BAMBU':
        name = 'Bambú';
        break;
      case 'MEZQUITE':
        name = 'Mezquite';
        break;
      case 'PIRUL':
        name = 'Pirul';
        break;
      default:
        name = 'Cabaña';
        break;
    }
    return name;
  };

  return (
    <div className="my-4 w-50">
      <Text
        w="32"
        mb="4"
        fontWeight="bold"
      >
        Tipo: {transformTipoCabana(membresia.tipo)}
      </Text>
      <div>
        <div>
          <label>{t('MEMBERSHIP_PRICE')}:</label>
          <input
            type="number"
            className="form-control my-2"
            value={precio}
            onChange={(e) => setPrecio(e.target.value)}
          />
          <label>{t('PRICE_PER_M2')}:</label>
          <input
            type="number"
            className="form-control  my-2"
            value={precioM2}
            onChange={(e) => {
              setPrecioM2(e.target.value);
            }}
          />
        </div>
      </div>
      <Button
        my="2"
        colorScheme="blue"
        isDisabled={isLoading || !precio || !precioM2}
        onClick={() => handleUpdateMembresia(membresia.id, precio, precioM2)}
      >
        {t('APPLY_CHANGES')}
      </Button>
      {(!precio || !precioM2) && (
        <span className="text-danger">
          {t('PRICE_AND_M2_REQUIRED')}
        </span>
      )}
    </div>
  );
};
